<template>
  <div>
    <div class="popupBlurBg" :class="{on: show}" @click.stop="methods.onClickClose"></div>
    <section class="slidePopup" :class="{on: show}">
      <div class="topArea">
        <p>{{ t('advance-guide') }}</p>
        <div class="exit" @click.stop="methods.onClickClose"></div>
      </div>
      <div class="scrollY">
        <div class="titleArea">
          <h2>{{ track.title }}</h2>
          <ul class="categoryArea">
            <li><svg xmlns="http://www.w3.org/2000/svg" width="14" height="6" viewBox="0 0 14 6" fill="none">
              <path d="M10.0647 0.701448L12.3662 2.99995L10.0647 5.29845" stroke="#9098AA" stroke-linecap="round"></path>
              <path d="M7.76622 0.699951L6.23389 5.29696" stroke="#9098AA" stroke-linecap="round"></path>
              <path d="M3.93533 0.701448L1.63384 2.99995L3.93533 5.29845" stroke="#9098AA" stroke-linecap="round"></path>
            </svg></li>
            <li v-for="(category, index) in track.categories" :key="index">{{ category }}</li>
          </ul>
        </div>
        <div
            v-for="(level, index) in track.trackLevelV2DTOList"
            :key="index"
            class="trackLevelMenu"
            :class="{on : methods.isActiveLevel(index)}"
        >
          <div class="titleArea">
            <div class="progress">
              <div class="circleArea" :class="methods.levelClass(level.level)">
                <div class="step">{{ TrackLevelModel.levelInitials(level.level, isGeneralLevel) }}</div>
              </div>
            </div>
            <div class="titInfo">
              <h3>{{ level.trackLevelTitle }}</h3>
              <span class="caret" @click.stop="methods.onClickLevel(index)"></span>
            </div>
          </div>
          <div class="info">
            <pre v-html="level.trackLevelDescription"></pre>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import {useRoute} from 'vue-router';
import {computed, nextTick, onMounted, ref} from '#imports';
import {useDialogStore} from "~/store/dialog/dialogStore";
import {useI18n} from "vue-i18n";
import {TrackModel} from "~~/package/mapper/track/model/TrackModel";
import {TrackLevelModel} from "~~/package/mapper/track/model/TrackLevelModel";

const { t } = useI18n();

const dialogStore = useDialogStore();
const route = useRoute();
const show = ref(false)
const activeLevelList = ref<number[]>([])

const track = computed(() => {
  return dialogStore.options.props?.track as TrackModel
})

const isGeneralLevel = computed(() => {
  return TrackModel.isGeneralLevel(track.value.trackLevelV2DTOList)
})

onMounted(() => {
  if(track.value.trackLevelV2DTOList.length > 0) activeLevelList.value = [0];
  else activeLevelList.value = []
  nextTick(() => {
    setTimeout(() => {
      show.value = true
    }, 10)
  })
})


const methods = {
  onClickClose() {
    show.value = false
    setTimeout(dialogStore.close, 200)
  },
  levelClass(level: number) {
    const levelNumber = isGeneralLevel.value ? '_G' : Math.min(level, 3);
    return {
      [`levelBadge${levelNumber}`]: true
    }
  },
  isActiveLevel(index: number) {
    return activeLevelList.value.includes(index);
  },
  onClickLevel(index: number) {
    if(methods.isActiveLevel(index)) activeLevelList.value = activeLevelList.value.filter(number => number !== index)
    else activeLevelList.value = [...activeLevelList.value, index]
  }
}

</script>
